"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firestoreActions = exports.default = void 0;

var firestoreActions = _interopRequireWildcard(require("./firestore"));

exports.firestoreActions = firestoreActions;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var _default = {
  firestoreActions: firestoreActions
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-firestore/lib/actions/index.js
// module id = 425
// module chunks = 0